<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="conviveSvc"></yo-generic-datagrid-pn>
